import { render, staticRenderFns } from "./PromotionSettingsDateTimeField.vue?vue&type=template&id=efda4420&"
import script from "./PromotionSettingsDateTimeField.vue?vue&type=script&lang=ts&"
export * from "./PromotionSettingsDateTimeField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports